import * as api from '../api/makeRequest';
import * as logger from '../logging/logger';

export type AppMetricTags = { [key: string]: string };

export function sendAppMetric(area: string, topic: string, description: string, tags?: AppMetricTags): void {
    logger.log('Debug', `AppMetrics: sendAppMetric ${area} ${topic} ${description} ${JSON.stringify(tags)}`);

    api.makeRequest({
        method: 'POST',
        path: `metrics/${area}`,
        data: { topic, description, tags }
    }).catch(err => logger.log('Error', `AppMetrics: Error ${err.message}`));
}

export function sendDeprecatedDashboardMetric(metricDescription: string): void {
    logger.log('Debug', `AppMetrics: sendMetric ${metricDescription}`);

    api.makeRequest({
        method: 'POST',
        path: 'Metrics',
        data: { topic: 'Dashboard Tiles Counter', description: metricDescription }
    }).catch(err => logger.log('Error', `AppMetrics: Error ${err.message}`));
}
